export default "__VITE_ASSET__CxIJwc0j__"